import { render } from "./ShippingAddressModal.vue?vue&type=template&id=256e8f31&scoped=true"
import script from "./ShippingAddressModal.vue?vue&type=script&lang=js"
export * from "./ShippingAddressModal.vue?vue&type=script&lang=js"

import "./ShippingAddressModal.vue?vue&type=style&index=0&id=256e8f31&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256e8f31"]])

export default __exports__